import { useTranslation } from 'react-i18next';
import { useVersionCheck } from './useVersionCheck';

const VersionUpdateBanner = () => {
    const { t } = useTranslation();
    const { updateAvailable, reload, snooze } = useVersionCheck();

    if (!updateAvailable) return null;

    return (
        <div
            role="status"
            aria-live="polite"
            className="sticky top-0 z-50 w-full bg-blue-600 text-white px-4 py-2 flex items-center justify-between gap-3 shadow-md"
        >
            <span className="text-sm font-medium">{t('versionCheck.message')}</span>
            <div className="flex items-center gap-2">
                <button
                    type="button"
                    onClick={snooze}
                    className="text-sm underline opacity-80 hover:opacity-100"
                >
                    {t('versionCheck.later')}
                </button>
                <button
                    type="button"
                    onClick={reload}
                    className="text-sm font-semibold bg-white text-blue-700 px-3 py-1 rounded hover:bg-gray-100"
                >
                    {t('versionCheck.reload')}
                </button>
            </div>
        </div>
    );
};

export default VersionUpdateBanner;
